import axios from "axios";

// const getToken = () => {
//   let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : localStorage.getItem('token');
//   let role = sessionStorage.getItem('role') ? sessionStorage.getItem('role') : localStorage.getItem('role');
//   let user_name = sessionStorage.getItem('user_name') ? sessionStorage.getItem('user_name') : localStorage.getItem('user_name');
//   let company_code = sessionStorage.getItem('company_code') ? sessionStorage.getItem('company_code') : localStorage.getItem('company_code');
//   return { token, role, user_name, company_code }
// }

// const loginCsc = async () => {
//   try {
//     const infoUser = {
//       token: getToken().token,
//       role: getToken().role,
//       timeExpired: new Date,
//       username: getToken().user_name,
//       companyCode: getToken().company_code
//     }
//     const res = await axios.post(`${process.env.REACT_APP_CAM_SERVICE_CENTER}auth/login`, infoUser);
//     const tokenSt = sessionStorage.getItem('tokenCsc') ? sessionStorage.getItem('tokenCsc') : localStorage.getItem('tokenCsc');
//     sessionStorage.setItem("tokenCsc", res.data)
//     if(tokenSt) {
//       window.location.reload()
//     }
//     return res.data;
//   } catch (error) {
//     // console.log('er', error);
//   }
// }

// const getTokenCsc = async () => {
//   try {
//     let token;
//     const tokenSt = sessionStorage.getItem('tokenCsc') ? sessionStorage.getItem('tokenCsc') : localStorage.getItem('tokenCsc');
//     if (tokenSt) {
//       token = tokenSt;
//     } else {
//       token = await loginCsc();
//     }
//     return { token }
//   } catch (error) {
//     throw error
//   }
// }

const axiosClientFSRUpLoadFile = axios.create({
  baseURL: `${process.env.REACT_APP_FSR}`,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

axiosClientFSRUpLoadFile.interceptors.request.use(async (config) => {
  try {
    // const authToken = (await getTokenCsc()).token;
    // config.headers.token = authToken;
    return config;
  } catch (error) {
    console.error('Failed to set token in request headers:', error);
    return Promise.reject(error);
  }
});
axiosClientFSRUpLoadFile.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  async (error) => {
    // if (getToken().token && error?.response?.status === 401) {
    //   // // console.log(getToken().refresh, getToken().token);
    //   async function refreshToken() {
    //     try {
    //       const res = await axios.post(
    //         `${process.env.REACT_APP_API_URL}authenticator/refreshToken/`,
    //         {
    //           refresh: getToken().refresh,
    //         },
    //         {
    //           headers: {
    //             "Content-Type": "application/json",
    //             // "X-Forwarded-For": `${sessionStorage.getItem("ip")}`,
    //           },
    //         }
    //       );
    //       sessionStorage.setItem("token", res.data.access);
    //       localStorage.setItem("token", res.data.access);
    //       // // console.log('done set token');
    //       // sessionStorage.setItem("token", res.data.access);
    //       window.location.reload()
    //     } catch (error) {
    //       if (error?.response?.status === 401) {
    //         // // console.log(getToken());
    //         window.location.replace('/login')
    //       }
    //     }
    //   }
    //   refreshToken();
    // }
    // // console.log(error);
    // debugger
    // await loginCsc()
    // window.location.reload()
    throw error;
  }
);
export default axiosClientFSRUpLoadFile;
